import React from 'react';
import './WaveAnimation.css';

const WaveAnimation = () => {
  return (
    <div className="wave-container">
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
      <div className="wave-bar"></div>
    </div>
  );
};

export default WaveAnimation;
